import { render, staticRenderFns } from "./audioList.vue?vue&type=template&id=45c04bee&scoped=true&"
import script from "./audioList.vue?vue&type=script&lang=js&"
export * from "./audioList.vue?vue&type=script&lang=js&"
import style0 from "./audioList.vue?vue&type=style&index=0&id=45c04bee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c04bee",
  null
  
)

export default component.exports